import React from 'react';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import logo from './yashvitech-logo.png';
import './Whatsapp.css';

function Whatsapp() {
  return (
    <FloatingWhatsApp
      phoneNumber="8640091593"
      accountName="YashviTech IT Solution"
      avatar={logo}
      // RIGHT side positioning
      buttonStyle={{ left: '25px', right: 'auto', bottom: '25px' }}
      chatboxStyle={{ left: '25px', right: 'auto', bottom: '95px' }}
    />
  );
}

export default Whatsapp;